var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoachesHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_486",
    "data-name": "Group 486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 541.352,
    height: 335.031,
    viewBox: "0 0 541.352 335.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 541.352,
    height: 335.031,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M53.7,18.4a9.2,9.2,0,1,1,9.19-9.213A9.2,9.2,0,0,1,53.7,18.4M444.148,238.878a25.205,25.205,0,0,1,0-50.41h3.006a26.2,26.2,0,0,0,0-52.4H388.91s-42.6-1.954-50.787-26.293c-8.211-24.346-14.818-36.582-61.65-36.582H241.79a17.384,17.384,0,0,1,0-34.768h11.52a12,12,0,0,0,0-24.01H181.827C151.014,14.417,149.656,0,137.443,0H79.489a9.2,9.2,0,0,0,0,18.4h8.83a13.315,13.315,0,1,1,0,26.631H38.239a34.228,34.228,0,1,0,0,68.456h39.6a32.917,32.917,0,1,1,0,65.833,77.853,77.853,0,0,0,0,155.706H493.272a48.076,48.076,0,1,0,0-96.152Z",
    transform: "translate(0 0.001)",
    fill: "#cce8c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M258.388,143.143c140.669,0,254.715,5,254.715,11.169,0,6.136-114.047,11.143-254.715,11.143-140.692,0-254.741-5.007-254.741-11.143,0-6.169,114.049-11.169,254.741-11.169",
    transform: "translate(4.2 164.846)",
    fill: "#aaef9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M74.805,173.674c-2.911-3.649-6.984-6.655-8.187-11.152-1.42-5.315,1.7-10.9.936-16.327C66.58,139.345,60,134.919,56.409,129c-3.516-5.807-1.868-7.746-2.182-14.513-.486-10.186-8.854-23.042-19.976-19.6-11.3,3.492-9.456,14.018-7.479,21.912,1.429,5.629.495,6.453-.886,12.079-1.665,6.814-7.034,13.422-4.781,20.047,1.375,4.12,5.424,6.9,6.877,10.971,1.64,4.624-.361,9.654-1.115,14.5-1.624,10.235.714,18.734,8.114,27.164a29.354,29.354,0,0,0,2.5,2.134c10.416-.6,22.119-1.13,34.951-1.624l.095-.11c6.78-7.408,8.8-20.131,2.283-28.294",
    transform: "translate(23.679 108.621)",
    fill: "#ddeab0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M35.01,99.161a.914.914,0,0,0-1.162-.51.88.88,0,0,0-.51,1.153,64.311,64.311,0,0,1,2.244,7.253c-.243-.243-.51-.465-.777-.691a21.144,21.144,0,0,0-4.135-2.558.894.894,0,0,0-1.177.445.862.862,0,0,0,.424,1.179,18.456,18.456,0,0,1,3.759,2.339,16.138,16.138,0,0,1,2.73,2.8c1.138,5.446,1.891,11.324,2.56,17.51a33.73,33.73,0,0,0-3.313-4.34,23.287,23.287,0,0,0-6.788-5.166.867.867,0,0,0-1.177.4.9.9,0,0,0,.4,1.207,21.245,21.245,0,0,1,6.255,4.781,33.516,33.516,0,0,1,5.093,7.518l.181,1.672c.377,3.69.755,7.473,1.218,11.318a.177.177,0,0,0,.024.118q.707,6.074,1.734,12.346a50.2,50.2,0,0,0-6.225-7.9,37.508,37.508,0,0,0-10.728-7.856.869.869,0,0,0-1.177.424.855.855,0,0,0,.4,1.177,36.37,36.37,0,0,1,10.233,7.5,53.621,53.621,0,0,1,8.43,11.7A143.854,143.854,0,0,0,47.889,179.9v.024c.91,2.8,1.939,5.629,3.092,8.454a51.174,51.174,0,0,0-22.25-11.24.892.892,0,0,0-1.067.667.907.907,0,0,0,.667,1.067,49.991,49.991,0,0,1,13.17,5.056A50.85,50.85,0,0,1,52.715,192.4q1.168,2.637,2.537,5.274l1.962-.069a120.654,120.654,0,0,1-7.591-18.155,34.219,34.219,0,0,1,1.562-13.06,47.359,47.359,0,0,1,6.782-13.28.886.886,0,1,0-1.444-1.026,49.972,49.972,0,0,0-7.057,13.749,37.785,37.785,0,0,0-1.577,7.834,188.155,188.155,0,0,1-5.25-28.169,55.709,55.709,0,0,1,3.516-9.7,20.2,20.2,0,0,1,4.183-6.091.9.9,0,0,0-1.224-1.319A22.827,22.827,0,0,0,44.531,135a51.838,51.838,0,0,0-2.4,6.035c-.267-2.386-.512-4.742-.762-7.057l-.172-1.805a.131.131,0,0,0-.024-.086C39.9,119.8,38.635,108.658,35.01,99.161",
    transform: "translate(28.061 113.539)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M61.415,157.53c-3.116-1.672-6.851-2.558-9.011-5.336-2.558-3.275-2.048-8.077-4.206-11.64-2.692-4.49-8.609-5.626-12.856-8.673-4.144-3.006-3.587-4.85-5.807-9.456-3.359-6.963-13-13.461-19.715-7.748-6.853,5.786-2.449,12.574,1.3,17.486,2.644,3.5,2.244,4.342,2.958,8.682.839,5.226-.934,11.412,2.6,15.376,2.182,2.449,5.809,3.2,8.038,5.6,2.535,2.739,2.621,6.829,3.507,10.44a23.312,23.312,0,0,0,6.608,11.765c8.9-.691,19.38-1.31,31.192-1.891a17.336,17.336,0,0,0,2.182-4.209c2.535-7.18.181-16.638-6.782-20.4",
    transform: "translate(7.174 129.544)",
    fill: "#ddeab0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M12.071,115.878a.682.682,0,0,0-.973.957A43.9,43.9,0,0,1,14.81,121.2c-.243-.071-.486-.157-.729-.228a14.726,14.726,0,0,0-3.649-.549.639.639,0,0,0-.691.643.665.665,0,0,0,.643.706,14.212,14.212,0,0,1,3.311.495,12.72,12.72,0,0,1,2.739,1.153c2.4,3.471,4.671,7.324,6.963,11.436a23.3,23.3,0,0,0-3.58-2.025,17.062,17.062,0,0,0-6.255-1.6.663.663,0,0,0-.706.628.638.638,0,0,0,.62.706,16.564,16.564,0,0,1,5.784,1.491,24.943,24.943,0,0,1,5.762,3.735l.628,1.115q2.024,3.673,4.2,7.52c.024.024.047.047.047.071,1.538,2.668,3.154,5.383,4.9,8.075a39.731,39.731,0,0,0-6.7-3.649A28.423,28.423,0,0,0,18.3,148.63a.677.677,0,0,0-.714.643.684.684,0,0,0,.652.714,26.8,26.8,0,0,1,9.34,2.182,41.1,41.1,0,0,1,9.347,5.65,110.959,110.959,0,0,0,8.054,10.5c1.467,1.687,3.021,3.335,4.645,4.977a38.938,38.938,0,0,0-18.82-1.241.681.681,0,0,0-.534.779.658.658,0,0,0,.777.557,37.452,37.452,0,0,1,10.659-.4,39.514,39.514,0,0,1,10.321,2.6c1.183,1.067,2.41,2.143,3.673,3.187l2-.095a90.224,90.224,0,0,1-11.655-11.208,26.1,26.1,0,0,1-2.8-9.545,36.495,36.495,0,0,1,.8-11.262.646.646,0,0,0-.51-.8.658.658,0,0,0-.8.519,36.844,36.844,0,0,0-.824,11.655,26.74,26.74,0,0,0,1.224,5.941,142.789,142.789,0,0,1-12.017-18.067,41.311,41.311,0,0,1-.424-7.81,15.47,15.47,0,0,1,1.115-5.493.7.7,0,0,0-.361-.886.665.665,0,0,0-.886.353,17.026,17.026,0,0,0-1.224,5.964,37.652,37.652,0,0,0,.086,4.914c-.886-1.6-1.758-3.163-2.6-4.695l-.667-1.2c0-.024-.024-.047-.024-.071-4.521-8.161-8.721-15.571-14.065-21.112",
    transform: "translate(11.216 133.217)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M195.4,175.954c3.154-3.978,7.63-7.253,8.94-12.165,1.538-5.784-1.868-11.883-1.022-17.824,1.069-7.473,8.258-12.3,12.174-18.758,3.8-6.334,2.018-8.454,2.378-15.838.51-11.122,9.631-25.163,21.781-21.4,12.346,3.83,10.321,15.3,8.161,23.939-1.553,6.145-.534,7.031.96,13.194,1.827,7.432,7.675,14.622,5.226,21.873-1.506,4.473-5.917,7.52-7.5,11.969-1.805,5.046.377,10.524,1.224,15.814,1.76,11.169-.777,20.445-8.875,29.66A34.077,34.077,0,0,1,235.785,209c-11.216-.581-23.719-1.091-37.337-1.562-.172-.2-.353-.377-.557-.581-7.408-8.092-9.607-22-2.487-30.9",
    transform: "translate(220.028 102.888)",
    fill: "#ddeab0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M224.549,94.643a.951.951,0,0,1,1.263-.555.934.934,0,0,1,.557,1.239,77.133,77.133,0,0,0-2.472,7.927c.29-.267.581-.516.871-.762a24,24,0,0,1,4.514-2.78.97.97,0,0,1,1.293.465.954.954,0,0,1-.469,1.3,20.28,20.28,0,0,0-4.114,2.558,15.773,15.773,0,0,0-2.958,3.07c-1.248,5.938-2.072,12.344-2.8,19.085a32.741,32.741,0,0,1,3.625-4.716,24.917,24.917,0,0,1,7.387-5.65.969.969,0,0,1,1.31.445,1.011,1.011,0,0,1-.448,1.312,23.272,23.272,0,0,0-6.829,5.2,36.628,36.628,0,0,0-5.555,8.213l-.181,1.85c-.424,4-.848,8.137-1.358,12.346v.108c-.534,4.4-1.153,8.9-1.915,13.484a55.2,55.2,0,0,1,6.788-8.632,41.212,41.212,0,0,1,11.7-8.563,1,1,0,0,1,1.31.465.972.972,0,0,1-.471,1.293,39.864,39.864,0,0,0-11.145,8.163,58.85,58.85,0,0,0-9.207,12.77,161.286,161.286,0,0,1-4.764,18.467v.024c-1,3.068-2.111,6.136-3.382,9.207a58.5,58.5,0,0,1,9.411-6.562,56.914,56.914,0,0,1,14.866-5.7.98.98,0,0,1,1.177.738.968.968,0,0,1-.732,1.179,54.2,54.2,0,0,0-14.377,5.491,56.237,56.237,0,0,0-12.213,9.256c-.934,2.048-1.915,4.095-2.982,6.167l-2.158-.095a129.309,129.309,0,0,0,8.5-20.2,37.355,37.355,0,0,0-1.687-14.259,52.13,52.13,0,0,0-7.41-14.483.96.96,0,0,1,.222-1.356.987.987,0,0,1,1.358.217,53.089,53.089,0,0,1,7.675,15.046,38.726,38.726,0,0,1,1.734,8.538,204.293,204.293,0,0,0,5.738-30.74A61.063,61.063,0,0,0,212.4,134.6a22.953,22.953,0,0,0-4.583-6.655.983.983,0,0,1-.047-1.36.964.964,0,0,1,1.381-.045,24.916,24.916,0,0,1,5.007,7.212,54.045,54.045,0,0,1,2.623,6.584c.29-2.606.557-5.188.824-7.7l.2-1.975v-.1c1.4-13.39,2.8-25.578,6.741-35.923",
    transform: "translate(229.529 108.269)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M212.793,158.332c3.382-1.82,7.455-2.8,9.835-5.824,2.786-3.587,2.229-8.837,4.559-12.705,2.958-4.9,9.411-6.139,14.041-9.482,4.536-3.264,3.916-5.265,6.341-10.321,3.673-7.58,14.166-14.661,21.538-8.428,7.447,6.317,2.644,13.7-1.429,19.063-2.89,3.83-2.442,4.74-3.227,9.482-.934,5.713,1,12.454-2.849,16.772-2.378,2.692-6.332,3.492-8.759,6.121-2.763,3-2.872,7.449-3.854,11.389a25.178,25.178,0,0,1-7.337,12.974c-9.725-.652-21.028-1.272-33.638-1.829a19.233,19.233,0,0,1-2.629-4.938c-2.78-7.856-.2-18.177,7.408-22.274",
    transform: "translate(235.274 125.736)",
    fill: "#ddeab0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M258.076,112.874a.75.75,0,0,1,1.044,0,.716.716,0,0,1,.024,1.028,55.2,55.2,0,0,0-4.049,4.779c.267-.086.534-.172.824-.243a17.081,17.081,0,0,1,3.963-.62.746.746,0,0,1,.039,1.491,15.268,15.268,0,0,0-3.625.534,13.207,13.207,0,0,0-2.958,1.263c-2.646,3.785-5.1,7.991-7.606,12.479a24.021,24.021,0,0,1,3.916-2.22,19.284,19.284,0,0,1,6.829-1.734.756.756,0,0,1,.777.691.745.745,0,0,1-.714.777,17.924,17.924,0,0,0-6.3,1.6,27.291,27.291,0,0,0-6.294,4.1l-.691,1.2c-1.467,2.694-2.982,5.424-4.583,8.211-.024.039-.024.062-.041.086-1.67,2.911-3.43,5.855-5.345,8.813a43.561,43.561,0,0,1,7.3-4.011,31.562,31.562,0,0,1,10.7-2.487.725.725,0,0,1,.76.714.741.741,0,0,1-.691.777,29.281,29.281,0,0,0-10.186,2.378,44.064,44.064,0,0,0-10.212,6.162,124.183,124.183,0,0,1-8.768,11.46h-.022q-2.4,2.766-5.071,5.431a41.7,41.7,0,0,1,8.477-1.782,42.95,42.95,0,0,1,12.056.424.75.75,0,0,1,.6.863.741.741,0,0,1-.848.6,41.974,41.974,0,0,0-11.662-.448,43.945,43.945,0,0,0-11.255,2.825c-1.381,1.3-2.849,2.558-4.355,3.806l-2.229-.11a97.349,97.349,0,0,0,13.129-12.525,28.563,28.563,0,0,0,3.047-10.44,39.318,39.318,0,0,0-.871-12.275.753.753,0,0,1,.557-.9.763.763,0,0,1,.871.581,40.981,40.981,0,0,1,.91,12.723,30.651,30.651,0,0,1-1.334,6.474,153.92,153.92,0,0,0,13.1-19.707,45.288,45.288,0,0,0,.471-8.525,17.209,17.209,0,0,0-1.2-5.979.733.733,0,1,1,1.336-.6,18.882,18.882,0,0,1,1.358,6.522,44.747,44.747,0,0,1-.11,5.338c.957-1.711,1.915-3.43,2.825-5.119L242.7,136c.024-.047.024-.071.047-.095,4.936-8.9,9.521-16.976,15.328-23.027",
    transform: "translate(239.405 129.745)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M121.292,28.826c-.91,12.5-2.754,14.237-14.676,15.195,11.922.957,13.766,2.692,14.676,15.195.919-12.5,2.763-14.237,14.685-15.195-11.922-.957-13.766-2.692-14.685-15.195m48.5,33c-.486,6.672-1.467,7.615-7.832,8.125,6.365.51,7.346,1.42,7.832,8.114.486-6.694,1.47-7.6,7.858-8.114-6.388-.51-7.371-1.452-7.858-8.125M148.551,10.406c-.495,6.765-1.491,7.7-7.92,8.211,6.429.534,7.425,1.467,7.92,8.232.51-6.765,1.491-7.7,7.942-8.232-6.451-.512-7.432-1.446-7.942-8.211",
    transform: "translate(122.781 11.984)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M129.706,122.3c.738,10.141,2.229,11.522,11.907,12.322-9.678.777-11.169,2.158-11.907,12.307-.738-10.149-2.244-11.531-11.9-12.307,9.654-.8,11.16-2.182,11.9-12.322m-39.289,26.74c.4,5.407,1.2,6.136,6.341,6.56-5.14.424-5.941,1.179-6.341,6.586-.4-5.407-1.2-6.162-6.367-6.586,5.166-.424,5.966-1.153,6.367-6.56m17.2-41.668c.4,5.493,1.224,6.248,6.451,6.672-5.226.424-6.05,1.177-6.451,6.646-.4-5.469-1.2-6.222-6.429-6.646,5.228-.424,6.029-1.179,6.429-6.672",
    transform: "translate(96.795 123.658)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M181.91,108.822c-.572,7.77-1.711,8.837-9.121,9.433,7.41.581,8.548,1.672,9.121,9.411.557-7.739,1.719-8.83,9.1-9.411-7.384-.6-8.546-1.663-9.1-9.433m30.084,20.468c-.314,4.135-.91,4.716-4.873,5.031,3.963.308,4.559.886,4.873,5.024.29-4.138.91-4.716,4.873-5.024-3.963-.314-4.583-.9-4.873-5.031m-13.17-31.9c-.314,4.206-.934,4.787-4.936,5.117,4,.314,4.622.9,4.936,5.1.305-4.2.91-4.781,4.912-5.1-4-.329-4.607-.91-4.912-5.117",
    transform: "translate(198.987 112.152)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M107.107,54.095h6.515L108.1,94.758H101.59Z",
    transform: "translate(116.993 62.297)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M104.223,2.1H214.9l-.886,6.655H103.3Z",
    transform: "translate(118.967 2.423)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M97.52,51.29h110.7l-.91,6.655H96.625Z",
    transform: "translate(111.275 59.066)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M98.93,104.371H201.5L214.978,5.2H112.414Z",
    transform: "translate(113.93 5.985)",
    fill: "#f1f8fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M99.135,104.284H201.5L214.918,5.5H112.58Zm102.409.4H98.868l.047-.2L112.376,5.305l.047-.2H215.185l-.024.2L201.677,104.48l-.039.2Z",
    transform: "translate(113.858 5.877)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M125.836,54.095h6.522l.2,40.663H126.04Z",
    transform: "translate(144.915 62.297)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M137.407,54.095h6.522L151,94.758h-6.515Z",
    transform: "translate(158.24 62.297)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M99.7,124.444H207.677c5.87,0,10.657-4.292,10.657-9.616v-5.807c0-5.289-4.787-9.607-10.657-9.607H99.7c-5.87,0-10.659,4.318-10.659,9.607v5.807c0,5.323,4.79,9.616,10.659,9.616",
    transform: "translate(102.546 114.487)",
    fill: "#87b7e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M212.567,97.138c9.058,0,16.419,6.655,16.419,14.818v5.188c0,8.163-7.361,14.81-16.419,14.81H82.439v-4.888H212.567c6.074,0,10.988-4.426,10.988-9.921v-5.188c0-5.472-4.914-9.921-10.988-9.921H82.439v-4.9Z",
    transform: "translate(94.938 111.866)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M93.24,124.444H208.967c3.744,0,6.765-2.739,6.765-6.1V105.514c0-3.367-3.021-6.1-6.765-6.1H93.24c-3.744,0-6.788,2.733-6.788,6.1v12.832c0,3.359,3.045,6.1,6.788,6.1",
    transform: "translate(99.56 114.487)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M99.7,140.191H207.677c5.87,0,10.657-4.292,10.657-9.613v-5.8c0-5.3-4.787-9.616-10.657-9.616H99.7c-5.87,0-10.659,4.318-10.659,9.616v5.8c0,5.321,4.79,9.613,10.659,9.613",
    transform: "translate(102.546 132.622)",
    fill: "#87b7e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M212.567,112.9c9.058,0,16.419,6.631,16.419,14.795v5.188c0,8.187-7.361,14.818-16.419,14.818H82.439v-4.9H212.567c6.074,0,10.988-4.428,10.988-9.921v-5.188c0-5.472-4.914-9.921-10.988-9.921H82.439V112.9Z",
    transform: "translate(94.938 130.013)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M93.24,140.191H208.967c3.744,0,6.765-2.715,6.765-6.1V121.285c0-3.382-3.021-6.124-6.765-6.124H93.24c-3.744,0-6.788,2.741-6.788,6.124v12.809c0,3.382,3.045,6.1,6.788,6.1",
    transform: "translate(99.56 132.622)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M99.7,166.143H207.677c5.87,0,10.657-4.316,10.657-9.616V140.956c0-5.321-4.787-9.613-10.657-9.613H99.7c-5.87,0-10.659,4.292-10.659,9.613v15.571c0,5.3,4.79,9.616,10.659,9.616",
    transform: "translate(102.546 151.257)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M212.567,129.07c9.058,0,16.419,6.648,16.419,14.795v14.967c0,8.172-7.361,14.818-16.419,14.818H82.439v-4.888H212.567c6.074,0,10.988-4.428,10.988-9.93V143.865c0-5.478-4.914-9.9-10.988-9.9H82.439V129.07Z",
    transform: "translate(94.938 148.64)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M93.24,166.143H208.967c3.744,0,6.765-2.739,6.765-6.1v-22.6c0-3.382-3.021-6.1-6.765-6.1H93.24c-3.744,0-6.788,2.715-6.788,6.1v22.6c0,3.359,3.045,6.1,6.788,6.1",
    transform: "translate(99.56 151.257)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M108.5,103.281v12.974l-5.964-3.806v-9.168Z",
    transform: "translate(118.077 118.94)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M99.758,103.281v12.974l5.964-3.806v-9.168Z",
    transform: "translate(114.884 118.94)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M122.185,120.206v12.974l-5.964-3.806v-9.168Z",
    transform: "translate(133.842 138.432)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M113.448,120.206v12.974l5.964-3.806v-9.168Z",
    transform: "translate(130.649 138.432)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M104.044,136.41V153.9l-8.006-5.117V136.41Z",
    transform: "translate(110.599 157.092)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M92.3,136.41V153.9l8.036-5.117V136.41Z",
    transform: "translate(106.297 157.092)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M109.109,93.836h82.5c4.5,0,8.148-3.264,8.148-7.339V82.071c0-4.049-3.651-7.337-8.148-7.337h-82.5c-4.49,0-8.14,3.288-8.14,7.337V86.5c0,4.075,3.649,7.339,8.14,7.339",
    transform: "translate(116.278 86.065)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M195.349,72.994c6.915,0,12.542,5.078,12.542,11.3v3.987c0,6.222-5.626,11.3-12.542,11.3H95.925V95.84h99.424c4.648,0,8.406-3.374,8.406-7.556V84.3c0-4.183-3.759-7.559-8.406-7.559H95.925V72.994Z",
    transform: "translate(110.469 84.061)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M104.166,93.836H192.6a4.924,4.924,0,0,0,5.155-4.645V79.379a4.924,4.924,0,0,0-5.155-4.645H104.166a4.933,4.933,0,0,0-5.181,4.645L99,89.191a4.917,4.917,0,0,0,5.164,4.645",
    transform: "translate(113.993 86.065)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M109.109,105.879h82.5c4.5,0,8.148-3.3,8.148-7.339V94.105c0-4.064-3.651-7.337-8.148-7.337h-82.5c-4.49,0-8.14,3.273-8.14,7.337V98.54c0,4.043,3.649,7.339,8.14,7.339",
    transform: "translate(116.278 99.924)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M195.349,85.031c6.915,0,12.542,5.069,12.542,11.3v3.978c0,6.233-5.626,11.3-12.542,11.3H95.925v-3.735h99.424c4.648,0,8.406-3.384,8.406-7.567V96.333c0-4.183-3.759-7.567-8.406-7.567H95.925V85.031Z",
    transform: "translate(110.469 97.923)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M104.166,105.879H192.6a4.914,4.914,0,0,0,5.155-4.648V91.422a4.931,4.931,0,0,0-5.155-4.654H104.166a4.94,4.94,0,0,0-5.181,4.654L99,101.231a4.908,4.908,0,0,0,5.164,4.648",
    transform: "translate(113.993 99.924)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M88.273,102.707c-2.935-1.091-3.154-2.668-4.734-3.445-1.6-.777-1.782-2.158-.226-3.675,1.138.96,2.582,2.16,3.32,1.517.51-.4,2.22-.379,2.558.219,1.491,3.649,3.554,2.5,3.978,4.135.047,2.205-3.539,1.758-4.9,1.248",
    transform: "translate(94.707 110.08)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M103.361,99.763c-5.164-.086-9.011-.157-10.816-.753-1.915-.628-1.515-1.876-.424-3.83,4.876,2.339,3.587-.486,5.857-.133a13.932,13.932,0,0,0,7.118,2.715c1.31,1.044.777,1.954-1.734,2",
    transform: "translate(105.034 109.422)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M114.646,39.05a34.439,34.439,0,0,0-6.945-1.42q-.565,8.911-8.854-.11c-5.336.463-6.382.534-9.34,1.53-6.412,6.429-6.984,13.837-10.343,22.3a21.449,21.449,0,0,1,7.894,1.6c.534-2.048,1-3.673,1.358-4.921-.11,11.169-.133,18.822-.11,22.964,12.236,5.1,22.338,3.337,26.474-.626.039-9.921.133-17.779.219-23.562a28.461,28.461,0,0,0,4.073,4.206c3.006-3.6,5.048-5.069,6.767-7.2A94.37,94.37,0,0,0,114.646,39.05",
    transform: "translate(91.167 43.209)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M116.99,46.311c-6.429,2.81-10.941,5.14-13.5,6.969L102.327,51.5c-1.065,1.115-2.268,2.22-3.757,3.806a20.824,20.824,0,0,0,4.557,3.8q6.713-.765,14.82-10.674a6.523,6.523,0,0,0,3.735-1.915,3.5,3.5,0,0,0-1.239-2.558c2.244-1.538,3.152-2.646,2.692-3.3q-5.274,3.415-6.145,5.65",
    transform: "translate(113.515 46.826)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M111.818,57.433c-.243.957.753,6.631.91,9.592,1.624,10.562.243,24.29-.643,41.957-1.562,6.233-3.869,14.528-3.735,26.207-2.739.871-3.72.957-6.186.314-1.743-12.189-.557-21.959,1-26.45-.981-6.969-2.466-14.779-4.648-26.009-2.449,12.234-5.721,21.331-7.118,27.272-.29,6.61-1.562,15.556-2.229,26.788a10.971,10.971,0,0,1-5.409.557c-2.73-10.321-2.268-21.583-1.106-33.724,1.224-14.622-.8-31.127,1.224-36.849a44.7,44.7,0,0,0,1.467-9.026q15.317,5.332,26.474-.628",
    transform: "translate(94.129 66.141)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M85.289,62.867c-.643.11-1.272.2-1.853.267q-.058,7.407-.015,11.083a8.075,8.075,0,0,0,2.025.667c0-.338-.118-1.052-.118-1.358-.039-3.783-.039-7.322-.039-10.659m29.966-9.857a22.689,22.689,0,0,1-5.14-7.7,31.837,31.837,0,0,1,.2,4.962,28.472,28.472,0,0,0,3.871,3.963c.377-.448.729-.848,1.067-1.224M85.8,43.4c-.777,2.692-1.562,5.312-2.268,7.849-.024,2.158-.047,4.183-.047,6.1.51-.071,1.138-.086,1.868-.11q.107-7.875.448-13.837",
    transform: "translate(96.051 49.984)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M102.072,94.054a13.176,13.176,0,0,1,.047,2.849c4.073,1.868,3.382-.29,5.007-.338a7.778,7.778,0,0,1-.777-2.887,8.089,8.089,0,0,1-4.277.377M83.1,96.007a7.854,7.854,0,0,1-.228,2.025c1.091.91,2.339,1.844,3.029,1.272a2.581,2.581,0,0,1,1.846-.2,21.676,21.676,0,0,1-.645-3.516,10.163,10.163,0,0,1-4,.424",
    transform: "translate(95.438 107.88)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M112.728,61.89q-10.783,10.547-28.851.062c-2.025,5.721,0,22.228-1.224,36.849-1.162,12.142-1.624,23.405,1.106,33.727.228.047.448.062.652.086a10.163,10.163,0,0,0,4-.424c.243-.062.488-.133.753-.219.669-11.231,1.941-20.18,2.229-26.788,1.4-5.941,4.671-15.038,7.12-27.274,2.182,11.231,3.666,19.04,4.645,26.011-1.553,4.488-2.739,14.259-1,26.45.441.11.839.2,1.218.288a8.068,8.068,0,0,0,4.277-.377c.219-.069.439-.157.691-.226-.133-11.679,2.173-19.976,3.735-26.207.886-17.667,2.268-31.394.643-41.959",
    transform: "translate(94.129 71.274)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M101.213,90.674a17.54,17.54,0,0,0,7.21.691c.041-.6.086-1.2.159-1.782a19.161,19.161,0,0,1-7.41-.51c0,.534.024,1.067.041,1.6M82.038,92.793a16.893,16.893,0,0,0,7.591-.6c.06-.62.11-1.248.172-1.868a18.692,18.692,0,0,1-7.92.863c.047.542.11,1.076.157,1.609m7.227,3.931c.049-.62.095-1.224.136-1.844a18.584,18.584,0,0,1-6.986.62c.069.534.155,1.069.267,1.6a17.175,17.175,0,0,0,6.584-.379M108.292,93.3a19.273,19.273,0,0,1-6.924-.133c.026.534.073,1.067.136,1.624a17.491,17.491,0,0,0,6.717.29c.022-.6.047-1.209.071-1.782",
    transform: "translate(94.296 102.578)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M91.8,39.8a.505.505,0,0,1,.463.51.48.48,0,0,1-.51.471.536.536,0,0,1-.448-.534A.472.472,0,0,1,91.8,39.8",
    transform: "translate(105.154 45.837)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M92.745,47.2a24.8,24.8,0,0,1-5.188-7.9,6.167,6.167,0,0,1,2-2.332c2.9,3.023,4.74,4.719,6.5,5.738h.024c.024-.071.047-.157.062-.219a42.578,42.578,0,0,0,1.452-5.3,5.809,5.809,0,0,1,1.577,2.378,16.552,16.552,0,0,1,.779,7.118,20.173,20.173,0,0,0-1.648-2.04A11.731,11.731,0,0,0,96.08,42.7a12.28,12.28,0,0,0-1.868,2.087,16.678,16.678,0,0,0-1.467,2.41",
    transform: "translate(100.832 42.565)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M89.611,45.233a6.4,6.4,0,0,0,1.138-2.22c-.157-.51-.314-1.138-.495-1.891-3.154-2.246-3.578-3.871-1.216-4.876a6.474,6.474,0,0,1,1.711,2.5c.557-.024.024-1.467.329-2-.62-2.315-.062-3.029-.219-4.45,1.624-2.315,5.581-2.943,10.478-2.205.4,4.5,1.805,15.132-3.651,14.771l-.039.6a41.141,41.141,0,0,1-1.429,5.274l-.11.219c-1.758-1.02-3.6-2.692-6.5-5.721",
    transform: "translate(100.803 34.31)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M102.392,33.269c-4.873-.729-8.587-.463-10.214,1.853.159,1.42-.241,2.307.379,4.622-.314.534.069,1.805-.486,1.829a6.472,6.472,0,0,0-1.713-2.5c-2.362,1-1.936,2.629,1.218,4.876.181.753.336,1.381.495,1.891-5.543-3.273-7.991-11.193-2.92-14.881,1.026-6.571,10.463-.557,15.311-3.628,1.846,2.668-.579,5.919-2.07,5.934",
    transform: "translate(99.482 31.48)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M90.537,36.589a15.165,15.165,0,0,0,3.688.439l-.039.6c-.047.353-.133.708-.2,1.067h-.047a7.318,7.318,0,0,1-3.4-2.111",
    transform: "translate(104.264 42.137)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M88.8,31.034a1.326,1.326,0,0,0,.118-1.734,2.651,2.651,0,0,0-2.692.8c.51-.133,1.373.172,2.573.934",
    transform: "translate(99.3 33.652)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M88.7,30.292c-.471.51-.9.62-1.272.338a3.072,3.072,0,0,1,.424-2.543,3.749,3.749,0,0,0,.848,2.205",
    transform: "translate(100.564 32.346)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M92.233,31.309c.015-1.429.572-2.268,1.64-2.558a4.656,4.656,0,0,1,2.982,3.916c-.6-.714-2.158-1.177-4.622-1.358",
    transform: "translate(106.217 33.11)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M90.712,27.78c.219.6-.071,1.405.777,1.577.581,2.606,2.629-.91,2.582-1.891-.353.29-1.491.385-3.359.314",
    transform: "translate(104.466 31.63)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M91.926,41.4a.5.5,0,0,1,.448.519.48.48,0,0,1-.519.463.529.529,0,0,1-.439-.534.477.477,0,0,1,.51-.448",
    transform: "translate(105.277 47.681)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M92.028,43.01a.494.494,0,0,1,.448.51.485.485,0,0,1-.51.471.528.528,0,0,1-.448-.534.476.476,0,0,1,.51-.448",
    transform: "translate(105.394 49.529)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M89.518,43.284,105.8,46.571a2.372,2.372,0,0,1,1.844,2.786l-4.536,22.4a2.355,2.355,0,0,1-2.778,1.827L84.048,70.293a2.355,2.355,0,0,1-1.853-2.78L86.74,45.13a2.351,2.351,0,0,1,2.778-1.846",
    transform: "translate(94.601 49.789)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M89.026,43.575l16.286,3.311a1.7,1.7,0,0,1,1.334,1.986l-4.559,22.4a1.675,1.675,0,0,1-1.977,1.31L83.823,69.271a1.692,1.692,0,0,1-1.334-1.979l4.559-22.407a1.671,1.671,0,0,1,1.977-1.31",
    transform: "translate(94.959 50.144)",
    fill: "#ddeab0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 23.562,
    height: 17.246,
    transform: "matrix(0.207, -0.978, 0.978, 0.207, 178.739, 117.124)",
    fill: "#edf4d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M88.2,43.687l2.849.583.133-.6a1.2,1.2,0,1,1,2.354.486l-.11.6,2.849.579a.759.759,0,0,1,.581.871l-.29,1.36a.683.683,0,0,1-.848.547l-8.1-1.616a.747.747,0,0,1-.557-.871l.267-1.356a.762.762,0,0,1,.871-.583m4.245-.243a.522.522,0,0,0-.62.4.552.552,0,0,0,.424.645.54.54,0,0,0,.62-.417.522.522,0,0,0-.424-.628",
    transform: "translate(100.24 49.181)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M80.058,48.634a18.632,18.632,0,0,0-.329,7.763c1.444,2.229,7.313.981,22.446-1.665a4.147,4.147,0,0,0,3.385.8c1.577-.424,1.646-.848,3.421-2.606a3.212,3.212,0,0,0-.267-3.139c-2,1.224-3.045,1.891-5.291,1.962.6-1.6.691-2.653.267-3.116a4.683,4.683,0,0,0-1.515,2.911c-11.922-.557-15.061-.486-16.662.4.172-.8.329-1.491.463-2.063a19.569,19.569,0,0,0-5.917-1.248",
    transform: "translate(91.513 56.008)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M91.194,31.763a.627.627,0,0,0-.643.667.709.709,0,0,0,.51.824c.329.039.6-.252.643-.667a.749.749,0,0,0-.51-.824",
    transform: "translate(104.274 36.573)",
    fill: "#bad9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M91.061,33.254a.709.709,0,0,1-.51-.824.627.627,0,0,1,.643-.667.551.551,0,0,1,.329.219l-.039-.024c-.118-.024-.2.095-.2.228a.239.239,0,0,0,.157.267.244.244,0,0,0,.219-.228V32.2a1.985,1.985,0,0,1,.047.385c-.047.415-.314.706-.643.667",
    transform: "translate(104.274 36.573)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M93.557,31.933l.047.047c-.024-.062-.11-.157-.133-.219.024.039.047.039.086.086a1.072,1.072,0,0,1,.071.133c0-.062-.024-.086-.024-.133a.225.225,0,0,1,.047.133.444.444,0,0,0-.071-.29.36.36,0,0,1,.11.267c.024-.024.024-.062.024-.11a.2.2,0,0,1,.024.11l.047-.039c0,.015-.024.039-.024.062a.655.655,0,0,0,.2-.353c-.024.039-.039.133-.062.157,0-.071.024-.157.024-.252-.024.071-.024.133-.047.2a.236.236,0,0,1-.071.157.63.63,0,0,0,.024-.361v.228a.566.566,0,0,0-.11-.314.678.678,0,0,0,.071.133c-.047-.047-.071-.133-.157-.157.039.047.062.071.11.133a.348.348,0,0,1,.047.2c-.047-.228-.157-.338-.314-.361a.715.715,0,0,1,.181.157c-.024.071,0-.039,0,.024a.316.316,0,0,0,.062.086c.024.024.024.047.024.095.024,0,.024.024.024.039v.024a.6.6,0,0,0-.181-.29.777.777,0,0,0-.267-.133l.071.024c.148.095.306.181.353.377-.024,0,0,0-.024-.015-.047-.071-.062-.118-.11-.181-.071-.047-.11-.086-.181-.133a1.622,1.622,0,0,0-.4-.11,1.908,1.908,0,0,1,.29.086.362.362,0,0,1,.219.157.134.134,0,0,0-.086-.047,2.315,2.315,0,0,0-.753-.219,1.711,1.711,0,0,1,.4.133h-.071c.024,0,.047.024.071.024a.247.247,0,0,0,.062.039.739.739,0,0,1,.314.267.315.315,0,0,1-.086-.062.276.276,0,0,0-.118-.086c-.062-.047-.133-.095-.2-.133a4.677,4.677,0,0,0-.486-.181c.015,0,.039.024.062.047a4.873,4.873,0,0,0-.753-.133c.086.015.219.015.306.039l.071.047c-.047,0-.2-.047-.267-.047a3.621,3.621,0,0,0-.824-.11,1.662,1.662,0,0,0-.643.086,1.993,1.993,0,0,0-.377.228,1.115,1.115,0,0,0-.095.086,1.787,1.787,0,0,1,.471-.267,3.454,3.454,0,0,0-.738.557c.071-.047.133-.11.2-.157a1.789,1.789,0,0,1,.2-.157,2.575,2.575,0,0,1,.51-.243,1.446,1.446,0,0,1-.2.11,8,8,0,0,0-1.02.714c-.024.024-.118.11-.133.133a1.038,1.038,0,0,1,.2-.157,3.013,3.013,0,0,1,.753-.4,6.154,6.154,0,0,0-.753.424L90,31.918a1.868,1.868,0,0,1,.51-.181,3.539,3.539,0,0,0-.957.448c.071-.024.157-.095.243-.118a2.6,2.6,0,0,1,.267-.11,2.778,2.778,0,0,1,.581-.157,3.749,3.749,0,0,1,.777,0c.071,0,.157.024.219.024a.451.451,0,0,0-.2-.039c-.157-.024-.314-.024-.448-.047-.062,0-.2.024-.243.024a1.811,1.811,0,0,1,.486-.047c-.015,0-.015,0-.015-.024H91.2a1.805,1.805,0,0,1,.353.047c.11.024.314.11.338.11-.024-.024-.047-.024-.071-.047l.243.047-.306-.11c.062.024.157.047.2.062a1.221,1.221,0,0,1,.314.095,1.217,1.217,0,0,0,.314.039c-.024-.015-.133-.039-.181-.062l-.157-.071c-.047,0-.062,0-.086-.015a1.718,1.718,0,0,1-.243-.118,2.473,2.473,0,0,0-.738-.133,1.659,1.659,0,0,1,.753.118l.338.148c.047,0,.062.024.086.024.095.047.181.071.267.11l-.024-.015v-.024a.707.707,0,0,0,.157.062c-.062-.086-.29-.157-.353-.243a1.089,1.089,0,0,1,.219.133c.024,0,.047.024.071.024a.9.9,0,0,0-.243-.243l-.118-.047a.434.434,0,0,1,.252.133,1.317,1.317,0,0,1,.172.2c.024.015.024,0,.024.015l-.062-.133c0,.024.11.133.11.157,0-.062-.047-.11-.071-.172l.047.039a1.526,1.526,0,0,0-.377-.306c.11,0,.306.172.4.267.024.062.039.133.086.148l-.047-.086.071.071a.871.871,0,0,0-.181-.29.325.325,0,0,0,.095.062.46.46,0,0,0,.062.071,1.1,1.1,0,0,1,.11.219.447.447,0,0,0-.039-.133c.015,0,.015,0,.039.024a.44.44,0,0,1,.071.11v-.086l.039.086a.981.981,0,0,1-.039-.181c.039.024.039.095.062.133.024-.015,0-.062,0-.086l.071.071c0,.015.024.039.039.062a.725.725,0,0,0-.086-.157.515.515,0,0,1,.133.157.556.556,0,0,0-.11-.243c.062.024.11.2.157.243v-.062L93.4,32v-.11c.024.024.024.062.047.11v-.133h.024a1.23,1.23,0,0,0,.062.11l-.039-.086c.024.024.024,0,.024.024Z",
    transform: "translate(102.908 35.908)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M93.528,31.69c.314.047.51.4.486.824-.024.4-.29.706-.6.667a.723.723,0,0,1-.471-.824c.024-.424.29-.714.581-.667",
    transform: "translate(107.033 36.489)",
    fill: "#bad9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M93.419,33.181c.306.039.572-.267.6-.667.024-.424-.172-.777-.486-.824a.406.406,0,0,0-.338.11h.047c.086,0,.157.133.157.267-.024.133-.095.219-.2.2-.086,0-.157-.133-.157-.267v-.024a1.163,1.163,0,0,0-.086.377.723.723,0,0,0,.471.824",
    transform: "translate(107.033 36.488)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M92.779,31.972c0,.024-.024.024-.024.039.024-.062.071-.148.095-.219a.775.775,0,0,1-.047.086c-.024.047-.047.095-.071.133,0-.062.024-.086.024-.133-.024.024-.024.095-.039.133a.886.886,0,0,1,.062-.282.486.486,0,0,0-.086.267.177.177,0,0,1-.024-.118.213.213,0,0,0-.024.118l-.024-.047c0,.047.024.047.024.062a.467.467,0,0,1-.133-.353.308.308,0,0,0,.047.157c0-.071-.024-.157-.024-.219a.38.38,0,0,1,.024.172,1.046,1.046,0,0,1,.039.157,2.759,2.759,0,0,1,0-.353v.219c.024-.11,0-.219.095-.29-.024.047-.047.071-.047.11.024-.039.047-.133.11-.148a.489.489,0,0,0-.086.133.271.271,0,0,0-.047.2c.047-.219.133-.314.228-.353-.024.024-.118.11-.118.157v.015a.6.6,0,0,1-.062.095.12.12,0,0,1-.024.086v.071a.628.628,0,0,1,.133-.29c.047-.047.133-.133.2-.133l-.047.024a.535.535,0,0,0-.267.377v-.024h.024c.024-.071.039-.11.062-.181a1.606,1.606,0,0,1,.133-.11.586.586,0,0,1,.29-.133.888.888,0,0,0-.2.086.315.315,0,0,0-.181.157c.024,0,.047-.024.062-.039a1.078,1.078,0,0,1,.534-.2.727.727,0,0,0-.282.133l.062-.024c-.024,0-.024.024-.047.024a.187.187,0,0,1-.039.047.557.557,0,0,0-.243.29.214.214,0,0,1,.062-.095A.787.787,0,0,0,93,31.682a1.451,1.451,0,0,1,.157-.133,2.347,2.347,0,0,1,.338-.181c0,.024-.024.024-.047.047.11,0,.29-.11.534-.133a.913.913,0,0,1-.2.062l-.071.024c.047,0,.157-.039.2-.039a1.267,1.267,0,0,1,.6-.095.77.77,0,0,1,.448.095,2.178,2.178,0,0,1,.267.219.543.543,0,0,1,.062.086c-.062-.039-.2-.243-.329-.267a2.075,2.075,0,0,1,.51.534,1.086,1.086,0,0,1-.133-.157,1.6,1.6,0,0,0-.157-.133.8.8,0,0,0-.353-.243.377.377,0,0,1,.133.11,4.333,4.333,0,0,1,.729.691.649.649,0,0,0,.095.133c-.024,0-.11-.11-.133-.157a2.71,2.71,0,0,0-.534-.377,3.646,3.646,0,0,1,.534.424l-.314-.219a1.358,1.358,0,0,0-.353-.2,2.826,2.826,0,0,1,.667.471.8.8,0,0,0-.181-.133A1.767,1.767,0,0,1,95.29,32a1.107,1.107,0,0,0-.415-.133,1.462,1.462,0,0,0-.557-.024.364.364,0,0,1-.157.024c.024-.024.11-.024.157-.047.086,0,.2-.024.306-.024.047,0,.133.024.157,0a1.578,1.578,0,0,0-.329-.047h.024v-.015a.786.786,0,0,0-.252.062c-.086.024-.243.086-.243.086a.044.044,0,0,0,.047-.039l-.181.062.228-.11a.27.27,0,0,0-.133.047,2.359,2.359,0,0,0-.228.086.921.921,0,0,1-.219.047c.024-.024.086-.047.11-.071l.133-.039c.024-.024.047-.024.062-.047a.382.382,0,0,1,.181-.086c.095-.071.4-.2.51-.157-.133-.071-.439.062-.534.133l-.243.133c-.024,0-.047.024-.062.039a1.256,1.256,0,0,0-.181.095v-.047a.289.289,0,0,1-.11.071c.039-.071.2-.133.243-.252a1.235,1.235,0,0,0-.157.133c0,.024-.024.024-.047.047a1.08,1.08,0,0,1,.181-.243l.086-.071c-.062,0-.133.095-.172.133-.047.071-.095.133-.133.2-.024.024,0,.024-.024.024l.062-.133a.811.811,0,0,0-.086.157c0-.071.047-.118.071-.181l-.047.047a1.525,1.525,0,0,1,.267-.314.925.925,0,0,0-.29.29A.852.852,0,0,0,93.25,32l.015-.118-.039.071a.721.721,0,0,1,.157-.29c-.047.024-.047.047-.071.071a.147.147,0,0,0-.062.086c-.024.047-.047.133-.071.2a.336.336,0,0,1,.024-.133l-.024.024a.357.357,0,0,0-.062.11l.015-.086-.039.086a.709.709,0,0,1,.039-.172c-.039.024-.039.086-.062.133v-.095l-.047.071c0,.024-.024.047-.024.062a.276.276,0,0,1,.047-.148c-.047.039-.047.086-.086.172a.4.4,0,0,1,.086-.243c-.047,0-.086.181-.11.219v-.062l-.047.086v-.11a.164.164,0,0,0-.024.11V31.9H92.85c-.024.047-.024.095-.047.11l.024-.086v.024Z",
    transform: "translate(106.534 35.963)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M92.223,36.288a.555.555,0,0,1,.286-.054c.349-.019.824-.041.884-.663A15.471,15.471,0,0,0,92.26,32.3l0,0h0A14.629,14.629,0,0,1,93.4,35.572c-.062.628-.562.652-.891.669a.635.635,0,0,0-.288.047",
    transform: "translate(106.206 37.192)",
    fill: "#f09171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M91.612,35.44c1.93.783,3.116.689,3.531-.4a3.876,3.876,0,0,1-2.04.095c-1.319-.23-3.32-.448-1.491.306",
    transform: "translate(104.656 40.211)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M182.429,166.143h107.94c5.878,0,10.659-4.316,10.659-9.616V140.956c0-5.321-4.781-9.613-10.659-9.613H182.429c-5.9,0-10.683,4.292-10.683,9.613v15.571c0,5.3,4.781,9.616,10.683,9.616",
    transform: "translate(197.786 151.257)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M295.261,129.07c9.056,0,16.419,6.648,16.419,14.795v14.967c0,8.172-7.363,14.818-16.419,14.818H165.14v-4.888H295.261c6.074,0,10.995-4.428,10.995-9.93V143.865c0-5.478-4.921-9.9-10.995-9.9H165.14V129.07Z",
    transform: "translate(190.179 148.64)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M175.938,166.143H291.672c3.737,0,6.765-2.739,6.765-6.1v-22.6c0-3.382-3.027-6.1-6.765-6.1H175.938c-3.735,0-6.788,2.715-6.788,6.1v22.6c0,3.359,3.053,6.1,6.788,6.1",
    transform: "translate(194.797 151.257)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M186.772,136.41V153.9l-8.036-5.117V136.41Z",
    transform: "translate(205.836 157.092)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5647",
    "data-name": "Path 5647",
    d: "M175,136.41V153.9l8.03-5.117V136.41Z",
    transform: "translate(201.538 157.092)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5648",
    "data-name": "Path 5648",
    d: "M22.927,140.191H130.876c5.87,0,10.659-4.292,10.659-9.613v-5.8c0-5.3-4.789-9.616-10.659-9.616H22.927c-5.893,0-10.674,4.318-10.674,9.616v5.8c0,5.321,4.781,9.613,10.674,9.613",
    transform: "translate(14.111 132.622)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M135.76,112.9c9.058,0,16.419,6.631,16.419,14.795v5.188c0,8.187-7.361,14.818-16.419,14.818H5.654v-4.9H135.76c6.074,0,11.012-4.428,11.012-9.921v-5.188c0-5.472-4.938-9.921-11.012-9.921H5.654V112.9Z",
    transform: "translate(6.511 130.013)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M16.432,140.191H132.159c3.744,0,6.765-2.715,6.765-6.1V121.285c0-3.382-3.021-6.124-6.765-6.124H16.432c-3.744,0-6.765,2.741-6.765,6.124v12.809c0,3.382,3.021,6.1,6.765,6.1",
    transform: "translate(11.133 132.622)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M22.927,166.143H130.876c5.87,0,10.659-4.316,10.659-9.616V140.956c0-5.321-4.789-9.613-10.659-9.613H22.927c-5.893,0-10.674,4.292-10.674,9.613v15.571c0,5.3,4.781,9.616,10.674,9.616",
    transform: "translate(14.111 151.257)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M135.76,129.07c9.058,0,16.419,6.648,16.419,14.795v14.967c0,8.172-7.361,14.818-16.419,14.818H5.654v-4.888H135.76c6.074,0,11.012-4.428,11.012-9.93V143.865c0-5.478-4.938-9.9-11.012-9.9H5.654V129.07Z",
    transform: "translate(6.511 148.64)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M16.432,166.143H132.159c3.744,0,6.765-2.739,6.765-6.1v-22.6c0-3.382-3.021-6.1-6.765-6.1H16.432c-3.744,0-6.765,2.715-6.765,6.1v22.6c0,3.359,3.021,6.1,6.765,6.1",
    transform: "translate(11.133 151.257)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M27.271,136.41V153.9l-8.03-5.117V136.41Z",
    transform: "translate(22.159 157.092)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M15.507,136.41V153.9l8.036-5.117V136.41Z",
    transform: "translate(17.858 157.092)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M195.035,76.1c.691-.306,4.473-.243,8.234.542a7.13,7.13,0,0,1-.96-2.386c-6.717-1.02-6.05-2.668-5.807-3.423,1.358-3.61,2.182-5.9,1.2-6.969a3.328,3.328,0,0,0-1.954,2.362c-.424-.243-.981-.6-1.052-1.067-.148-1.444-.11-4.45-1.749-4.693-.338,1.31-.628,2.715-.871,4.2-.667.542-3.163,10.016,2.982,10.84Z",
    transform: "translate(219.971 69.632)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M196.779,74.18c-.243.751.981,2.4,5.941,3.916.732-.116,1.334-.848,2-1.162a8.672,8.672,0,0,0,3.965-3.382c3.916-6.562.267-9.7-1.719-10.9-.441-6.782-10.635-1.506-15.3-5.093-2.137,2.535.047,6.074,1.562,6.255,1.64.241,1.6,3.251,1.749,4.695.071.463.6.824,1.052,1.067a3.073,3.073,0,0,1,1.358-1.964c.439-.28.549-.439.777.049.581,1.2-.157,3.27-1.381,6.522",
    transform: "translate(219.697 66.284)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M198.6,61.778c-.714-.777-.824-1.444-.314-2a4.7,4.7,0,0,1,3.854,1.067c-.738-.172-1.939.133-3.539.934",
    transform: "translate(227.981 68.78)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M197.649,61.211c.353.714.777.957,1.287.762a3.394,3.394,0,0,0,.314-2.935,4.439,4.439,0,0,1-1.6,2.173",
    transform: "translate(227.617 67.989)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M202.123,59.642c.047,1.844-.886,2.911-2.825,3.225-3.359-1.153-5.3-2.887-5.786-5.226q1.733,1.472,8.611,2",
    transform: "translate(222.852 66.381)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M202.792,68.16c-.329-1.891-1.782-2.849-4.34-2.849-5.715-3.625-5.1,1.467-4.757,4.536,1.287-1.2,3.266-.534,9.1-1.687",
    transform: "translate(222.827 73.771)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M194.1,67.061c.471-.934,1.429-1.216,2.872-.91,3.869-1.153,2.763,1.358,2.072,2.9-.557-.762-1.805-.667-4.944-1.986",
    transform: "translate(223.53 75.843)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M234.571,77.527c-1.868-1.743-7.049-3.649-10.164-4.607a71.426,71.426,0,0,0-10.588-.534q-9.711-.107-20.892.2c-7.346-3.58-9.3-3.892-13.013-5.581-1.115-.493-3.116-1.562-4.7-2.4-.729.353-1.663,2-1.977,3.4,7.808,7.5,12.817,10.461,15.69,12.1a91.044,91.044,0,0,0,14.881,2.694q1.73,11.183,2.621,21.512c-1.216,7.275-1.82,12.221-1.749,14.842q17.047,2.543,27.336.133a61.653,61.653,0,0,0-1.577-7.229c.753-9.323,1.954-15.4,2.582-19.692a46.99,46.99,0,0,0,5.964,9.616,108.094,108.094,0,0,0-4.12,13.861,6.005,6.005,0,0,0,3.43,2.134c1.8-3.139,5.715-10.306,6.743-15.642.729-4.295-7.858-21.443-10.463-24.8",
    transform: "translate(199.501 74.395)",
    fill: "#c5e862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M201.674,68.274a7.933,7.933,0,0,1,1.091,1.287l-.243-.062a70.555,70.555,0,0,0-10.283-.534,6.151,6.151,0,0,1,1.162-1.2c.691-.338,4.467-.267,8.273.51",
    transform: "translate(221.386 77.817)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M177.819,70.473a19.443,19.443,0,0,1-4.521-2.621c-.377-1.224-1.132-1.289-.936-2.362-1.794-2.113-2.2-2.152-3.047-2.537.732-1.177,2.406-.243,5.119,2.4,1.846,1.091,2.621.848,2.356-.684-1.108-1.067-1.091-1.986-.755-2.472.157.133.755.865,1.822,1.979a7.035,7.035,0,0,1,1.293,2.935,1.417,1.417,0,0,0,.172.534,6.943,6.943,0,0,0-1.5,2.825",
    transform: "translate(194.988 71.631)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M204.456,88.6a40.98,40.98,0,0,1-3.225,2.887l.024.157-.219.071c-.338.306-.691.691-1.091,1.106.777.652,1.782.2,2.982-1.263a4.488,4.488,0,0,1-1.3,3.673c-.439.51-.818.91-1.082,1.179.839,1.467,2.644.886,5.36-1.719a16.964,16.964,0,0,0,.8-2.961,15.319,15.319,0,0,1,.51-1.482,6.077,6.077,0,0,1-2.763-1.624Z",
    transform: "translate(230.26 102.032)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M215.5,90.244c1.358,9.207,2,23.711,1.915,37.688,1.31,6.648,1.248,17.26-.2,38.8a18.628,18.628,0,0,1-6.646.29c-3.337-20.092-4.609-30.547-3.83-38.331-1-5.6-2.4-15.862-4.185-23.877-1.758,8.015-3.154,18.272-4.183,23.877.8,7.785-.486,18.239-3.8,38.331a18.675,18.675,0,0,1-6.655-.29c-1.444-21.536-1.515-32.147-.2-38.8-.095-14.11.549-28.748,1.93-37.94q15.9,2.308,25.854.252",
    transform: "translate(215.098 103.637)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M194.181,128c.62.495.777,2.786.267,4.544a6.967,6.967,0,0,1-6.121-.275c-1-.4-2.2-1.067-2.175-1.773.041-1.381.065-1.405,2.89-2.872-.047.29-.086.534-.133.777.11.314.353.557.824.267.51-.329.353-1.42,1.805-1.444,1.224-.024,1.224,1.138,1.82,1.515.643.439.777-.228.824-.738",
    transform: "translate(214.375 146.518)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M198.626,128.018c-.62.495-.777,2.786-.267,4.544a6.919,6.919,0,0,0,6.121-.29c.282-.133,1.506-.534,1.6-.871.329-1.177.039-2.739-2.315-3.759.041.29.086.534.133.777-.11.314-.361.557-.824.267-.534-.353-.353-1.444-1.82-1.467-1.209-.024-1.209,1.138-1.805,1.538-.643.439-.8-.228-.824-.738",
    transform: "translate(228.083 146.506)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M192.753,126.021a20.092,20.092,0,0,0-.181,4.379c-.11.252-.338.361-.691.095-.6-.377-.6-1.538-1.82-1.515-1.452.024-1.3,1.115-1.805,1.444-.471.29-.714.047-.824-.267a26.174,26.174,0,0,0,.4-4.45,19.145,19.145,0,0,0,4.921.314",
    transform: "translate(215.851 144.767)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M198.3,126.021a20.092,20.092,0,0,1,.181,4.379c.11.228.314.338.691.095.6-.4.6-1.562,1.805-1.538,1.467.024,1.287,1.115,1.82,1.467.463.29.714.047.824-.267a24.492,24.492,0,0,1-.4-4.45,20.266,20.266,0,0,1-4.921.314",
    transform: "translate(228.364 144.767)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M195.459,78.963c.824,2.668,5.431,21.135,6.608,21.959,3.275,2.291,5.579,3.987,6.96,5.117-2.666-1.513-4.934-2.582-6.451-3.673-5.031-3.6-4.536,6.3-6.246,12.951-.073-2.621.534-7.565,1.749-14.842q-.9-10.337-2.621-21.512M182.885,67.927a8.269,8.269,0,0,0-2.4,1.758,14.88,14.88,0,0,1,4.1-.934c-.607-.29-1.164-.572-1.7-.824m42.344,17.047a29.03,29.03,0,0,1-.557,3.554c-.628,4.295-1.829,10.369-2.582,19.694a61.523,61.523,0,0,1,1.577,7.227c-.157.047-.29.071-.439.11a34.459,34.459,0,0,0-1.624-5.132c-.762-1.962-1.624-.628-4.254.148,3.359-2.958,2.653-2.025,3.468-6.476q2.069-10.97,4.411-19.126",
    transform: "translate(207.847 78.226)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M149.778,94.989c.682-.361,4.467-.5,8.3.11a7.565,7.565,0,0,1-1.067-2.362c-6.814-.669-6.233-2.38-6.029-3.156,1.177-3.7,1.891-6.029.863-7.081a3.474,3.474,0,0,0-1.868,2.5c-.424-.245-1-.557-1.091-1.044-.219-1.429-.329-4.45-2-4.63-.267,1.332-.486,2.761-.667,4.269-.91.8-.848,3.875-.11,7.41-.448,2,.777,3.116,3.649,3.359Z",
    transform: "translate(167.609 91.35)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M166.522,144.916s-.385,6.231-1.586,6.317c-.172.024-6.113.024-6.113.024l-7.615-.039a2.481,2.481,0,0,1,2.276-2.229c2.22-.377,5.934-1.939,7.292-4.9,1.405-3.068,5.745.824,5.745.824",
    transform: "translate(174.135 164.582)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M172.344,185.266a16.261,16.261,0,0,1-4.112.753,15.5,15.5,0,0,1-3.854-.534,100.712,100.712,0,0,0-2.827-13.476c-1.263-4.873-3.045-11.128-5.6-18.891-7.049-21.467-9.192-34.039-9.388-35.218a.352.352,0,0,1-.024-.093l.024-.015,21.695-9.53s-2.67,29.589.729,40.963a43.918,43.918,0,0,1,1.248,5.431c2.158,12.346,2.111,30.609,2.111,30.609",
    transform: "translate(168.755 124.679)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M170.218,154.656l-8.68,17.353c-1.265-4.873-3.047-11.128-5.6-18.891-7.047-21.465-9.19-34.039-9.385-35.216v-.11l21.693-9.53s-2.668,29.589.729,40.963a43.914,43.914,0,0,1,1.248,5.431",
    transform: "translate(168.768 124.678)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M158.659,144.916s-.4,6.231-1.6,6.317c-.151.024-6.115.024-6.115.024l-7.612-.039a2.481,2.481,0,0,1,2.276-2.229c2.22-.377,5.932-1.939,7.292-4.9,1.427-3.068,5.76.824,5.76.824",
    transform: "translate(165.063 164.582)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M144.742,108.585a308.428,308.428,0,0,0,3.021,42.72c3.344,23.56,2.205,33.544,2.205,33.544a21,21,0,0,0,3.2.8,14.3,14.3,0,0,0,4.74-.534s4.764-23.56,3.382-35.349c-1.358-11.765,6.515-40.42,6.515-40.42Z",
    transform: "translate(166.681 125.049)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M152.888,87.461S163.876,98.677,164.41,103.1c.557,4.426-5.407,11.341-5.407,11.341Z",
    transform: "translate(176.069 100.722)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M157.359,92.88l-4.144,3-6.2-.841c.041-.519.353-2.582.643-4.473a2.406,2.406,0,0,1,.041-.338c.228-1.6.445-2.974.445-2.974l5.629-2.827,2.1-1.05c0,.024-.073,1.758-.1,2.025a14.75,14.75,0,0,0,1.586,7.479",
    transform: "translate(169.304 96.018)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M147.883,88.922c.353.377,8.43-2,8.7-2.825.8.219,2.425,2.268,2.425,2.268l-12.417,3.068a8.67,8.67,0,0,1,1.3-2.511",
    transform: "translate(168.814 99.151)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M171.592,135.836c-1.224,5.611-21.669,6.278-26.968,1.186-.579-.581-.62-3.273-.4-6.924.448-7.094,1.87-17.8,1.939-23.27a42.862,42.862,0,0,1,.865-7.787,65.4,65.4,0,0,1,2.582-9.323s9.99-3.225,11.858-2.668c9.011,2.644,11.35,43.181,10.126,48.786",
    transform: "translate(165.95 100.175)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M144.159,124.2c.448-7.1,1.868-17.8,1.939-23.272a42.987,42.987,0,0,1,.863-7.782l6.012-1.046s5.872,23.978-8.813,32.1",
    transform: "translate(166.016 106.069)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M155.006,84.941c-1.153,2.2-5.784,4.292-7.692,5.071a2.663,2.663,0,0,1,.039-.338c.228-1.6.448-2.976.448-2.976l5.629-2.825c1.272-.095,2.048.148,1.577,1.067",
    transform: "translate(169.65 96.569)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M147.24,93.358s9.435,2.425,10.864-3.445c1.42-5.9,3.578-9.547-2.362-11.35-5.958-1.8-7.677.181-8.634,2.025-.934,1.853-2.268,11.993.133,12.77",
    transform: "translate(168.004 89.661)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M147.169,102.2s-.8,1.758-1.515,2.119a3.291,3.291,0,0,0-1.6,1.491,5.068,5.068,0,0,0,.643,3.869c.51.667-.047-2.315,2.8-3.006.919-.219,2.229-.91,2.229-2.2a17.052,17.052,0,0,0-.157-2.653Z",
    transform: "translate(165.745 117.26)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M147.722,103.427s-1.42,3.249-1.8,3.116c-.981-.314.086-1.452.015-2.362-.039-.62,1.782-.753,1.782-.753",
    transform: "translate(167.57 119.109)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M158.3,87.68c-8.523.329-18.868,18.4-17.534,22.267.871,2.487,6.631,11.081,7.989,11.081s4.938-.919,5.048-3.116c0,0-3.847-8.57-3.288-10.123.6-1.674,6.694-5.433,7.651-2.984,1.577,4.073.133-17.125.133-17.125",
    transform: "translate(161.975 100.974)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M151.681,92.916c-.2.777,1.13,2.378,6.184,3.649.732-.133,1.313-.91,1.98-1.272a8.375,8.375,0,0,0,3.783-3.6c3.625-6.806-.2-9.764-2.244-10.879-.809-6.812-10.793-1-15.666-4.387-2.025,2.692.329,6.145,1.868,6.231,1.672.181,1.782,3.2,2,4.632.095.486.667.8,1.091,1.044a3.05,3.05,0,0,1,1.287-2.048c.424-.314.542-.465.785.024.643,1.153,0,3.273-1.067,6.608",
    transform: "translate(166.907 88.014)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M152.941,80.363c-.762-.785-.9-1.429-.424-2.01a4.714,4.714,0,0,1,3.955.871c-.777-.157-1.954.219-3.531,1.138",
    transform: "translate(175.326 90.112)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M151.925,79.845c.4.691.848.919,1.334.691a3.45,3.45,0,0,0,.157-2.982,4.362,4.362,0,0,1-1.491,2.291",
    transform: "translate(174.96 89.313)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M155.844,78.9a2.972,2.972,0,0,1-3.2,2.92c-3.249-1.538-4.985-3.516-5.2-5.893,1.067,1.106,3.847,2.111,8.406,2.974",
    transform: "translate(169.793 87.434)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M157.423,86.57c-.424-1.891-1.915-2.778-4.5-2.644-5.943-3.359-5.048,1.734-4.583,4.8,1.248-1.263,3.3-.691,9.08-2.158",
    transform: "translate(170.443 95.38)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M148.813,87.2c.157-1.02.957-1.6,2.464-1.758,3.32-2.354,3.077.4,2.9,2.087-.777-.547-1.939-.086-5.36-.329",
    transform: "translate(171.376 97.352)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M144.107,109.866a51.149,51.149,0,0,0,15.414,2.087,28.009,28.009,0,0,0,12.309-2.982l.047-.973a29.444,29.444,0,0,1-12.372,3.068,52.7,52.7,0,0,1-15.4-2.205Z",
    transform: "translate(165.957 124.373)",
    fill: "#65840f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M45.389,120.206v12.974l-5.964-3.806v-9.168Z",
    transform: "translate(45.403 138.432)",
    fill: "#327a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M36.653,120.206v12.974l5.964-3.806v-9.168Z",
    transform: "translate(42.21 138.432)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M49.142,92.049A54.851,54.851,0,0,0,47.274,102.2c-.133,2.4-.329,4.316.934,5.917,0,0-3.154.353-4.221-.667a2.934,2.934,0,0,0,.4.729s-3.542.157-5.009-1.153c-1.444-1.31.062-29.793,9.874-27.407,0,0,9.8-.981,9.035,10.407.157,13.508,1.115,16.247,1.868,18.577-1.091.762-1.508.471-1.844-.6-.29-.957-.448-2.072-.536-2.362a31.74,31.74,0,0,0,.512,3.468s-3.957-.534-5.652-2.04-3.978-12.66-3.492-15.023",
    transform: "translate(44.807 91.525)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M83.074,88.413,70.28,88.256l-4.135,22.226,12.165,3.406Z",
    transform: "translate(76.174 101.637)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M81.292,88.856,76.928,112.1,66.67,109.254,70.5,88.723Z",
    transform: "translate(76.778 102.175)",
    fill: "#fcffee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M73.889,109.308H70.93v-6.515l1.868.51,1.091-5.855Z",
    transform: "translate(81.685 112.223)",
    fill: "#93d500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M53.355,106.743h46.1c.2,0,.353-.557.353-1.272v-.62c0-.714-.157-1.272-.353-1.272h-46.1c-.172,0-.353.557-.353,1.272v.62c0,.714.181,1.272.353,1.272",
    transform: "translate(61.038 119.285)",
    fill: "#4f6307",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M57.639,119.637s-7.765,12.064-8.807,12.6-3.673.643-2.694,2.621c.975,1.962,1.373,9.7,2.285,10.1.94.4,8.792,1.31,7.615,0s-1.893-.646-2.5-3.023c-.6-2.363-1.446-6.812-.329-7.746,1.138-.91,7.939-9.168,7.939-9.168Z",
    transform: "translate(52.886 137.776)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M71.819,122.049s9.435,15.569,11.193,16.974c1.758,1.373,7.518,3.494,2.8,3.849-4.716.333-7.008-1.579-9.968-2.477-2.982-.863-6.646-1.373-5.25-3.662,1.405-2.27.8-7.238-2.2-10.392-3.029-3.141,3.421-4.292,3.421-4.292",
    transform: "translate(77.837 140.554)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M48.019,105.272s23.388-.62,32.666,6.986c5.407,8.232,18.53,32.507,19.55,35.177-.682.691-4.622,1.954-6.38,1.782-5.164-6.169-11.993-11.483-14.708-16.309-3.335-5.943-4.357-8.925-9.788-9.435-5.431-.534-17.667-2.291-21.34-2.291s0-15.909,0-15.909",
    transform: "translate(53.424 121.219)",
    fill: "#45a831",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M42.4,104.521l13.594,2.339s18.059.172,26.316,1.711c7.518,1.4,8.632,9.945,0,21.695-4.9,6.67-9.035,12.015-17.51,18.02-2.137-1.577-2.961-2.182-3.563-5.988.6-.841,2.205-6.115,2.692-7.143,4.678-9.788,10.924-13.342,11.018-14.3-1.052-1.711-27.792,8.878-33.128,2.644-5.069-5.941.581-18.977.581-18.977",
    transform: "translate(45.726 120.369)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M42.85,90.29a14.393,14.393,0,0,1,10.659,2.644c2.974,3.053,6.341,8.053,6.136,16.309-.267,10.5,1.624,11.193-.353,14.065-8.193,3.4-22.25,17.949-18.939,2.33,2.41-11.3-5.25-19.707.919-32.257.51-1.02,1.13-2.025,1.577-3.092",
    transform: "translate(44.693 103.81)",
    fill: "#aaef9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M57.655,111.8c.157,5.472.934,7.072.338,8.807-3.344.338-9.459,1.672-11,3.806-1.758,2.449-3.492,2.8-2.692,1,.824-1.8,2.982-4.379-.329-13.187-3.344-8.789-4.9-14.756-1.648-20.869Z",
    transform: "translate(46.684 105.212)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M40.687,96.143A43.136,43.136,0,0,0,43.441,85.06l5.768,1.719s-3.273,7.339-.133,9.968a27.757,27.757,0,0,1,2.27,2.04,14.393,14.393,0,0,0-10.659-2.644",
    transform: "translate(46.856 97.957)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M42.009,86.273c.329-.29.777-.665,1.224-1.067l4.716,1.383v.022a19.182,19.182,0,0,0-1.474,5.76A16.738,16.738,0,0,1,41.781,87.7c.095-.542.157-1.007.228-1.431",
    transform: "translate(48.116 98.125)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M44.844,91.065c5.934,2.063,5.267,8.344,10.745,17.572,2.849,4.787,5.469,4.719,5.469,4.719a127.769,127.769,0,0,0,14.685-.936c5.03-.6,5.338.889,1.844,2.137-7.047,2.511-14.371,5.25-20.288,4.583-5.9-.643-16-15.728-16.529-19.644-.714-5.433,1.067-9.474,4.073-8.43",
    transform: "translate(46.772 104.683)",
    fill: "#f19651",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M69.731,128.147C76,131.2,79.361,132.958,81.386,132.8c.471-.047.871-.095,1.186-.133,2.244,1.31,5.8,2.866,1.8,3.18-4.716.336-7.008-1.579-9.968-2.474-2.982-.863-6.646-1.373-5.25-3.664a4.944,4.944,0,0,0,.581-1.562",
    transform: "translate(79.282 147.577)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M48.141,125.605c.148,4.983.839,9.9,3.869,10.814a5.1,5.1,0,0,0,2.182.2c.488.6,1.069.6,1.846,1.467,1.177,1.31-6.672.4-7.615,0-.91-.4-1.31-8.14-2.283-10.1-.809-1.624.815-2,2-2.378",
    transform: "translate(52.886 144.649)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    "data-name": "Path 5714",
    d: "M57.968,102.137c4.026-.071,8.03-2.449,10.014-2.119,1.979.361,7.41,4.63,6.586,4.789-.8.181-5.274-1.917-5.454-1.939a7.128,7.128,0,0,1-3.649,2.182c-2.733.689-.017-2.048-8.516.508-5.519,1.674,1.02-3.421,1.02-3.421",
    transform: "translate(63.033 115.146)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M41.283,88l-.6,4.764s5.2.314,7.808,1.782c2.582,1.444,6.405,5.652,6.405,5.652l-3.116-5.362-.441-3.453Z",
    transform: "translate(46.856 101.339)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M43.991,90.757c3.845-.714,5.65,2.739,8.163,8.413a82.12,82.12,0,0,0,7.627,13.413c.848.865,14.356,0,14.356,0s.4,3.894,0,4.357-2.739.4-2.739.4-.934.762-1.82,1.343c-.871.6-8.282,1.711-11.726,1.53-3.43-.181-6.586-.463-7.055-1-.465-.519-9.859-14.975-10.431-20.18-.581-5.188,1.648-7.9,3.625-8.279",
    transform: "translate(46.377 104.41)",
    fill: "#aaef9c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 12.15,
    height: 1.334,
    transform: "translate(143.425 221.531)",
    fill: "#93d500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M42.536,85.286c-2.425,8.053,6.184,17.51,10.745,10.141.086-.148,1.044-.039,1.138-.219.2-.353.062-1.248.282-1.624a14.768,14.768,0,0,0,1.319-3.423c1.13-3.987-.424-7.9-3.453-8.766-3.045-.848-8.9-.095-10.031,3.892",
    transform: "translate(48.499 93.376)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M55.7,81.073c7.322.329,6.16,11.341,6.16,11.341s-1.891.581-5.87-.062a21.486,21.486,0,0,0,.181-4.206,28.75,28.75,0,0,1-1.052,3.94c-.839.377-1.8.047-3.4-.353a7.232,7.232,0,0,1-4.811,5.493c-1.775.557-3.643,1.224-5.738.172-2.111-1.067-.957-11.789.157-13.947,1.672-3.225,4.45-6.136,9.278-4.607A37.521,37.521,0,0,1,55.7,81.073",
    transform: "translate(46.057 90.315)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M44.082,93.33a10.17,10.17,0,0,0,1.553-.133c2.535-.385,5.964-1.829,6.231-9.968a.211.211,0,0,0-.219-.243.232.232,0,0,0-.25.222c-.11,3.382-.777,5.87-2,7.432a5.518,5.518,0,0,1-3.821,2.087c-2.386.361-3.963-.086-4.693-1.31a.254.254,0,0,0-.338-.086.247.247,0,0,0-.086.329,3.887,3.887,0,0,0,3.625,1.672",
    transform: "translate(46.552 95.567)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 10.926,
    height: 1.334,
    transform: "translate(128.497 221.531)",
    fill: "#93d500"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 1.429,
    height: 0.486,
    transform: "translate(128.897 221.045)",
    fill: "#87b7e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 1.429,
    height: 0.581,
    transform: "translate(131.079 220.95)",
    fill: "#87b7e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 1.429,
    height: 0.691,
    transform: "translate(133.237 220.84)",
    fill: "#87b7e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 1.42,
    height: 0.777,
    transform: "translate(135.419 220.754)",
    fill: "#87b7e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 1.42,
    height: 0.886,
    transform: "translate(137.6 220.644)",
    fill: "#87b7e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M47.4,89c-.377-.062-1.734-.557-1-1.044a1.821,1.821,0,0,0,1.381.643l-.11.133-.11.095Z",
    transform: "translate(53.182 101.293)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M50.018,85.492c-.495-.267-2.739-1.067-2.543-.062a4.056,4.056,0,0,1,2.472.691l.024-.2.024-.157Z",
    transform: "translate(54.659 97.815)",
    fill: "#485644",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M48.972,86.051l0,0a1.157,1.157,0,0,0-1.218-.336,1.152,1.152,0,0,1,1.226.331l0,.006",
    transform: "translate(54.99 98.642)",
    fill: "#f09171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M180.77,45.193A35.805,35.805,0,1,1,144.965,9.388,35.8,35.8,0,0,1,180.77,45.193",
    transform: "translate(125.711 10.811)",
    fill: "#52cb3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M114.676,33.144v-10.2H118.7a4.105,4.105,0,0,1,1.977.441,3.045,3.045,0,0,1,1.248,1.22,3.659,3.659,0,0,1,.43,1.794,3.583,3.583,0,0,1-.439,1.794,3.049,3.049,0,0,1-1.267,1.211,4.293,4.293,0,0,1-2.005.432h-2.565v-1.73H118.3a2.176,2.176,0,0,0,1.028-.215,1.419,1.419,0,0,0,.607-.6,2.053,2.053,0,0,0,0-1.777,1.374,1.374,0,0,0-.609-.592,2.234,2.234,0,0,0-1.037-.213h-1.454v8.439Z",
    transform: "translate(132.063 26.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M118.9,33.144v-10.2h6.874v1.777h-4.718v2.431h4.363v1.777h-4.363v2.438h4.738v1.777Z",
    transform: "translate(136.926 26.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M122.892,33.144v-10.2h4.026a4.377,4.377,0,0,1,1.975.409,2.921,2.921,0,0,1,1.25,1.162,3.489,3.489,0,0,1,.43,1.762,3.345,3.345,0,0,1-.437,1.745,2.844,2.844,0,0,1-1.269,1.119,4.7,4.7,0,0,1-2,.389h-2.7V27.795h2.347a2.679,2.679,0,0,0,1.026-.17,1.233,1.233,0,0,0,.609-.508,1.629,1.629,0,0,0,.2-.841,1.712,1.712,0,0,0-.2-.858,1.285,1.285,0,0,0-.613-.529,2.566,2.566,0,0,0-1.033-.183H125.05v8.439ZM128.4,28.5l2.535,4.641h-2.38L126.076,28.5Z",
    transform: "translate(141.525 26.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 2.156,
    height: 10.201,
    transform: "translate(273.624 49.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M129,33.144v-10.2h2.156v8.424h4.374v1.777Z",
    transform: "translate(148.558 26.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M132.7,33.144v-10.2h2.156v8.424h4.374v1.777Z",
    transform: "translate(152.819 26.422)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachesHero);
export default __webpack_public_path__ + "static/media/coaches-hero.a377663c53dbf205c3c99942de939c43.svg";
export { ForwardRef as ReactComponent };